export interface UnitPriceGetQueryParams {
  isTokyo: boolean;
  isDairen: boolean;
}

export const EmptyUnitPriceGetQueryParams: UnitPriceGetQueryParams = {
  isTokyo: true,
  isDairen: false,
};
